import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useNavContext } from './useNavContext'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { determinePhoneAvailability } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/determinePhoneAvailability'
import Badge from '@toasttab/shared/src/components/atoms/Badge/Badge'

const SalesCta = () => {
  const [isAvailable, setIsAvailable] = useState(false)

  const { t } = useI18next()
  const { globalSettings } = usePageContext()
  const {
    isMobileNavOpen,
    navigationData,
    salesPhoneNumber,
    showSalesInDesktopNav,
    showSalesInMobileNav
  } = useNavContext()

  useEffect(() => {
    setIsAvailable(
      determinePhoneAvailability(
        globalSettings?.mobileSalesIndicatorSchedule?.schedule
      )
    )
  }, [globalSettings])

  // Request Demo Sales CTA styling
  const salesLinkClasses = classNames(
    // Base styling
    'font-effra items-center mr-4 lg:mr-6 font-semibold text-base lg:font-normal text-blue-75 lg:text-default lg:hover:text-blue-75 whitespace-nowrap',
    // Desktop icon
    'lg:before:content-icon-phone lg:before:h-6 lg:before:w-6 before:mr-1',
    // Desktop indicator
    'lg:after:content-[""] lg:after:w-[10px] lg:after:h-[10px] lg:after:rounded-full lg:after:ml-2',
    {
      // Mobile indicator for simple nav
      'max-[389px]:before:content-[""] max-[389px]:before:w-[10px] max-[389px]:before:h-[10px] max-[389px]:before:rounded-full max-[389px]:before:mr-2':
        !navigationData?.menus?.length,
      'max-[389px]:before:bg-grass-50 lg:after:bg-grass-50': isAvailable,
      'max-[389px]:before:bg-gray-50 lg:after:bg-gray-50': !isAvailable,
      'flex lg:hidden': showSalesInMobileNav && !showSalesInDesktopNav,
      'hidden lg:flex': !showSalesInMobileNav && showSalesInDesktopNav,
      flex: showSalesInMobileNav && showSalesInDesktopNav
    }
  )

  const salesBadgeClasses = classNames(
    'lg:hidden mr-1 font-sansPro text-[12px] leading-[14px] tracking-[1.2px]',
    {
      // Hide the badge on the simple nav, use dot indicator from salesLinkClases above
      'hidden min-[390px]:block': !navigationData?.menus?.length
    }
  )

  const phoneHref = `tel:${salesPhoneNumber?.replace(/[^0-9]/gi, '')}`

  return salesPhoneNumber &&
    (showSalesInMobileNav || showSalesInDesktopNav) &&
    !isMobileNavOpen ? (
    <a className={salesLinkClasses} data-testid='SalesCta' href={phoneHref}>
      <Badge
        badgeColor={isAvailable ? 'bg-grass-25' : 'bg-gray-50'}
        classes={salesBadgeClasses}
        text={t('Sales')}
        uppercase
      />
      <span className='hidden lg:block mr-1'>{t('Sales')}:</span>{' '}
      {salesPhoneNumber}
    </a>
  ) : null
}

export default SalesCta
